import React from 'react';
import ReactDOM from 'react-dom';
import '@synergycms_core/less/fonts.css';

import { Provider } from 'react-redux';


import App from './App';
import * as serviceWorker from './serviceWorker';
import ThemeProvider from '@synergycms_core/components/providers/themeProvider';
import ContentProvider from '@synergycms_core/components/providers/translateProvider';

import PopoverProvider from '@synergycms_core/components/providers/popoverProvider.jsx';
import { langCodeCorrector} from '@synergycms_core/utils/api';
import store from './configureStore.js';
import initializeStore from './start';

//Parametres basics

window.engineVersion = process.env.APP_VERSION;
console.log(window.engineVersion);

//Agreguem estils i element per defecte al body
if (process.env.NODE_ENV !== 'development') {
  /*const styleUrl = "https://synergy2.booking-channel.com/igm/synergycms_searchengine/build/static/css/main.css";
  if (document.createStyleSheet) {
    document.createStyleSheet(styleUrl);
  } else {
    var styles = "@import url('" + styleUrl + "');";
    var newSS = document.createElement('link');
    newSS.rel = 'stylesheet';
    newSS.href = 'data:text/css,' + escape(styles);
    document.getElementsByTagName("head")[0].prepend(newSS);
  }
  if (!is(Array, data) && !document.getElementById(data.element_id)) {
    var newDiv = document.createElement("div");
    newDiv.setAttribute("id", data.element_id);
    document.body.prepend(newDiv);
  }*/
}
/*
window.engine_sygy_data = {
      outer_web: true,
      //hotels_info: hotels,
      hotel_code: "E092",
      url: "https://www.eurostarshotels.com/disponibilidad.html",
      lang: "es",
      //city_id: "25287",
      auto_open: true
    };
var engine = document.createElement('script');
engine.setAttribute('src', "https://synergy2.booking-channel.com/igm/synergycms_searchengine/build/static/js/main.js?nomemcache");
document.head.appendChild(engine);
*/
initializeStore(store.dispatch, store.getState);

const generateReactDoom = () => {

  const  config =( window.frontLoader && window.frontLoader['cms-engine'] ) ? window.frontLoader['cms-engine'] : window.engine_sygy_data;

  if (config.lang) {
    config.lang = langCodeCorrector(config.lang);
  }

  const lang = config.config?.lang || config.lang || langCodeCorrector(window.lang_info ? window.lang_info.code : "es");
  const theme = config.config?.theme || config.theme
  const links = config.config?.links || config.links
  const themeValues = config.config?.theme_values || config.theme_values
  let extraInfo =  {}
  if(config.config?.extra){
    const {engine_left, ...other} = config.config.extra;
    extraInfo = {
      ...engine_left,
      ...other,//example my_booking
    }
  }

  ReactDOM.render(
    <Provider store={store}>
      <ContentProvider value={{
        lang: lang,
        theme: theme,
        i18n: config.i18n,
        links: {...links, ...extraInfo},
        fontIcons: config.theme_values?.fontFamily3 || "Icons"
      }}>
        <ThemeProvider value={{
          appId: config.element_id,
          theme: theme,
          themeValues: {...themeValues, ...config.config?.positions, ...config.config?.button_positions}
        }}>
          <PopoverProvider>
            <App />
          </PopoverProvider>
        </ThemeProvider>
      </ContentProvider>
    </Provider>, document.getElementById(config.element_id|| "default_sygy_element_engine"));
}


generateReactDoom();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


